import { render } from "./AppLoader.vue?vue&type=template&id=b728f1a2"
const script = {}

import "./AppLoader.vue?vue&type=style&index=0&id=b728f1a2&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__